/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Yesno_PlaceholderInputs */

const en_register_onboarding_personal_info_yesno_placeholder = /** @type {(inputs: Register_Onboarding_Personal_Info_Yesno_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please select…`)
};

const de_register_onboarding_personal_info_yesno_placeholder = /** @type {(inputs: Register_Onboarding_Personal_Info_Yesno_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte auswählen…`)
};

/**
* | output |
* | --- |
* | "Please select…" |
*
* @param {Register_Onboarding_Personal_Info_Yesno_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_yesno_placeholder = /** @type {((inputs?: Register_Onboarding_Personal_Info_Yesno_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Yesno_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_yesno_placeholder(inputs)
	return en_register_onboarding_personal_info_yesno_placeholder(inputs)
});